/* eslint-disable no-mixed-operators */
/* eslint-disable camelcase */
import React from 'react';
import { compose } from 'react-apollo';
import { withRouter } from 'react-router';
import { Modal, Icon } from 'semantic-ui-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from './messages';

import BusinessCalc from './BusinessCalc';
import LegacyCalculator from './LegacyCalculator';
import OfferCalculator from './OfferCalculator';

const quantityOptions = [];
for (let i = 0; i < 5; i += 1) {
  quantityOptions.push({ text: `${i + 1}`, value: `${i + 1}` });
}

class CalculatorModal extends React.Component {
  closeModal = () => {
    this.props.onClose();
  };

  render() {
    const countryCode =
      (this.props.currentUser &&
        this.props.currentUser.country &&
        this.props.currentUser.country.iso_code) ||
      'EG';

    return (
      <Modal
        size="small"
        onClose={this.closeModal}
        open={this.props.open}
        closeIcon
        trigger={this.props.children}
      >
        <Modal.Header>
          <Icon name="calculator" />
          <FormattedMessage {...messages.header} />
        </Modal.Header>
        {this.props.open && (
          <Modal.Content>
            {this.props.currentUser.isBusiness ?
              <BusinessCalc user={this.props.currentUser} />
              :
              <LegacyCalculator iso_code={countryCode} />}
          </Modal.Content>
        )}
      </Modal>
    );
  }
}

export default compose(withRouter, injectIntl)(CalculatorModal);



// WEBPACK FOOTER //
// ./app/components/CalculatorModal/index.js